import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

// Mapa de rota → label legível
const ROUTE_LABELS = {
    '/': 'Home',
    '/principal': 'Home',
    '/graficos': 'Gráficos',
    // Evento
    '/evento': 'Eventos',
    '/cadastroEvento': 'Evento',
    '/eventoPergunta': 'Perguntas do Evento',
    '/cadastroEventoPergunta': 'Pergunta',
    '/eventoOrdemServico': 'Ordens de Serviço',
    '/cadastroEventoOrdemServico': 'Ordem de Serviço',
    '/cadastroEventoOrdemServicoResumo': 'Resumo OS',
    '/eventoParticipante': 'Participantes',
    '/cadastroEventoParticipante': 'Participante',
    '/cadastroEventoParticipanteOperador': 'Participante (Operador)',
    '/eventoVincularParticipanteOperador': 'Vincular Operador',
    '/eventoRelatorioParticipante': 'Relatório de Participantes',
    '/eventoPalestrante': 'Palestrantes',
    '/cadastroEventoPalestrante': 'Palestrante',
    '/eventoCarta': 'Cartas',
    '/cartaFila': 'Fila de Envio',
    '/cadastroEventoCarta': 'Carta',
    '/eventoHistorico': 'Histórico',
    '/eventoResponsavelCliente': 'Responsáveis do Cliente',
    '/cadastroEventoResponsavelCliente': 'Responsável do Cliente',
    '/eventoResumoBackOffice': 'Resumo BackOffice',
    '/eventoResumoRsvp': 'Resumo RSVP',
    '/eventoResumoBook': 'Book do Evento',
    '/eventoRelatorio': 'Relatório de Eventos',
    '/cadastroEventoRsvp': 'RSVP',
    '/eventoDadosIniciaisRsvp': 'Dados Iniciais RSVP',
    '/cadastroEventoRsvpOpcaoAereo': 'Opção de Aéreo RSVP',
    '/cadastroEventoSolicitacoesAereo': 'Solicitações de Malha Aérea',
    '/cadastroEventoMalhasAereo': 'Malhas da Solicitação',
    '/cadastroEventoPortacaoAereo': 'Importação das Opções de Aéreo',
    '/cadastroEventoEmissaoEnvioAereo': 'Solicitar Emissão de Aéreo',
    '/cadastroEventoEmissaoAereo': 'Emissão de Aéreo',
    '/aereoFaturaCvc': 'Faturas CVC',
    '/aereo': 'Aéreo',
    '/rascunhoMalhaAereo': 'Rascunho de Malha',
    '/cadastroEventoSolicitacaoAereo': 'Solicitação de Malha Aérea',
    '/cadastroEventoImportarMalhaAereo': 'Importação Malha Aérea',
    '/cadastroEventoSugestaoAereo': 'Sugestão de Voos',
    '/cadastroEventoDiaQuantidade': 'Dias e Quantidades',
    '/cadastroEventoAgenda': 'Agenda',
    '/eventoImportarParticipante': 'Importar Participantes',
    '/eventoImportarAereo': 'Importar Aéreo',
    '/eventoImportarHospedagem': 'Importar Hospedagem',
    '/eventoImportarCartas': 'Importar Cartas',
    '/eventoImportarSanofi': 'Importar Sanofi',
    '/eventoImportarKpi': 'Importar KPI',
    '/eventoImportarEventos': 'Importar Eventos',
    '/eventoImportarOpcaoAereo': 'Importar Opção Aéreo',
    '/eventoImportarInscricoes': 'Importar Inscrições',
    '/eventoImportarPerguntasSatisfacao': 'Importar Perguntas',
    '/eventoParticipanteSituacao': 'Situações de Participantes',
    '/cadastroEventoParticipanteSituacao': 'Situação de Participante',
    '/relatorioListaPresenca': 'Lista de Presença',
    '/eventoLiberarStartRsvp': 'Liberar RSVP',
    '/exportarEventoExecucao': 'Exportar Execução',
    '/onePageEvento': 'One Page',
    '/checklist': 'Checklist',
    '/checklistItens': 'Itens de Checklist',
    '/eventoChecklistModelo': 'Modelos de Checklist',
    '/cadastroEventoChecklistModelo': 'Modelo de Checklist',
    '/cadastroEventoChecklist': 'Checklist do Evento',
    '/alterarEventoChecklist': 'Alterar Checklist',
    '/eventoChecklistAtividade': 'Atividades de Checklist',
    '/cadastroEventoChecklistAtividade': 'Atividade de Checklist',
    '/cadastroEventoSatisfacaoPergunta': 'Pergunta de Satisfação',
    '/eventoPerguntaQrCode': 'QR Code',
    // Orçamento
    '/orcamento': 'Orçamentos',
    '/solicitarAdiantamento': 'Solicitar Adiantamento',
    '/enviarParaFinanceiro': 'Enviar para o Financeiro',
    '/faturamentoEnvio': 'Enviar para Faturamento',
    '/cadastroOrcamento': 'Orçamento',
    '/resumoOrcamento': 'Resumo do Orçamento',
    '/importarOrcamento': 'Importar Orçamento',
    '/cadastroPagamentoOrcamento': 'Pagamento de Orçamento',
    '/orcamentoRelatorioPagamento': 'Relatório de Pagamentos',
    '/orcamentoModelo': 'Modelos de Orçamento',
    '/cadastroOrcamentoModelo': 'Modelo de Orçamento',
    '/configuracaoOrcamentoModelo': 'Configuração de Modelo',
    // Financeiro
    '/financeiro': 'Financeiro',
    '/financeiroParcelaPagar': 'Parcelas a Pagar',
    '/cadastroParcelaPagar': 'Parcela a Pagar',
    '/financeiroParcelaReceber': 'Parcelas a Receber',
    '/financeiroFaturamento': 'Faturamento',
    '/cadastroParcelaReceber': 'Parcela a Receber',
    '/financeiro/parcela-periodica': 'Parcelas Periódicas',
    '/financeiroRelatorioDre': 'DRE',
    '/financeiroPlanoConta': 'Plano de Contas',
    '/cadastroPlanoConta': 'Plano de Conta',
    '/financeiroCaixa': 'Caixa',
    '/cadastroCaixa': 'Caixa',
    '/financeiroParcelaRelatorio': 'Relatório Financeiro',
    '/financeiro/alterarContaFornecedor': 'Alterar Conta Fornecedor',
    // Cliente / Parceiros
    '/cliente': 'Clientes',
    '/cadastroCliente': 'Cliente',
    '/fornecedorGrupo': 'Grupos de Fornecedor',
    '/cadastroFornecedorGrupo': 'Grupo de Fornecedor',
    '/Fornecedor': 'Fornecedores',
    '/fornecedor': 'Fornecedores',
    '/cadastroFornecedor': 'Fornecedor',
    '/freelancer': 'Freelancers',
    '/cadastroFreelancer': 'Freelancer',
    '/hotel': 'Hotéis',
    '/cadastroHotel': 'Hotel',
    '/local': 'Locais',
    '/cadastroLocal': 'Local',
    '/pessoa': 'Pessoas',
    '/cadastroPessoa': 'Pessoa',
    '/empresa': 'Empresas',
    '/cadastroEmpresa': 'Empresa',
    '/participanteCategoria': 'Categorias de Participante',
    '/cadastroParticipanteCategoria': 'Categoria de Participante',
    // Produto
    '/produto': 'Produtos',
    '/cadastroProduto': 'Produto',
    '/produtoGrupo': 'Grupos de Produto',
    '/cadastroProdutoGrupo': 'Grupo de Produto',
    '/produtoBu': 'BU',
    '/cadastroProdutoBu': 'BU',
    '/produtoUnidadeNegocio': 'Unidades de Negócio',
    '/cadastroProdutoUnidadeNegocio': 'Unidade de Negócio',
    '/produtoLinha': 'Linhas de Produto',
    '/cadastroProdutoLinha': 'Linha de Produto',
    '/produtoTipoAtributo': 'Tipos de Atributo',
    '/cadastroProdutoTipoAtributo': 'Tipo de Atributo',
    '/produtoAtributo': 'Atributos',
    '/cadastroProdutoAtributo': 'Atributo',
    '/produtoOrcamento': 'Produtos de Orçamento',
    '/cadastroProdutoOrcamento': 'Produto de Orçamento',
    '/servicoOrcamento': 'Serviços de Orçamento',
    '/cadastroServicoOrcamento': 'Serviço de Orçamento',
    '/servicoOrcamentoRelatorio': 'Relatório de Serviços',
    // Compra / Venda
    '/venda': 'Vendas',
    '/cadastroVenda': 'Venda',
    '/relatorioCompraVenda': 'Relatório Compra/Venda',
    '/relatorioCompra': 'Relatório de Compras',
    '/compra': 'Compras',
    '/cadastroCompra': 'Compra',
    '/solicitarGasto': 'Solicitar Gasto',
    // Briefing
    '/briefing': 'Briefing',
    '/briefingCliente': 'Briefing do Cliente',
    '/listaBriefingCliente': 'Lista de Briefing',
    '/cadastroModeloBriefing': 'Modelo de Briefing',
    '/visualizarBriefing': 'Visualizar Briefing',
    '/cadastroBriefingAdvisoryBoard': 'Briefing Advisory Board',
    '/cadastroBriefingEventoTerceiro': 'Briefing Evento de Terceiro',
    '/cadastroBriefingOrganizadoSede': 'Briefing Org. pela Sede',
    '/cadastroBriefingOrganizadoForcaVendas': 'Briefing Força de Vendas',
    // SLA
    '/sla': 'SLA',
    '/cadastroSla': 'SLA',
    '/slaCriterio': 'Critérios de SLA',
    '/cadastroSlaCriterio': 'Critério de SLA',
    // RSVP
    '/rsvp': 'RSVP',
    // RH
    '/rhCargo': 'Cargos RH',
    '/cadastroRhCargo': 'Cargo RH',
    // Outros
    '/alterarSenha': 'Alterar Senha',
};

// Rotas públicas que não entram no trail
const ROTAS_IGNORADAS = ['/login', '/recuperar-senha', '/registro', '/loginEvento', '/loginConfirmarDados', '/loginRapido'];

function getLabel(pathname) {
    if (ROUTE_LABELS[pathname]) return ROUTE_LABELS[pathname];
    // Remove último segmento (ID numérico ou alfanumérico)
    const semId = pathname.replace(/\/[^/]+$/, '');
    if (semId && ROUTE_LABELS[semId]) return ROUTE_LABELS[semId];
    return null;
}

function ignorarRota(pathname) {
    return ROTAS_IGNORADAS.some(r => pathname.startsWith(r));
}

const BreadcrumbContext = createContext({ trail: [], setCurrentLabel: () => {} });

export function BreadcrumbProvider({ children }) {
    const location = useLocation();

    const [trail, setTrail] = useState(() => {
        try {
            return JSON.parse(sessionStorage.getItem('bc_trail') || '[]');
        } catch (e) {
            return [];
        }
    });

    // Rotas de primeiro nível (itens diretos do menu lateral).
    // Ao navegar para qualquer uma delas, o trail é RESETADO — não acumulado.
    const TOP_LEVEL_ROUTES = [
        '/graficos',
        '/pessoa',
        '/cliente',
        '/fornecedor',
        '/participanteCategoria',
        '/freelancer',
        '/cadastroEventoParticipanteOperador',
        '/evento',
        '/eventoLiberarStartRsvp',
        '/orcamento',
        '/solicitarGasto',
        '/financeiro',
        '/notaFiscal',
        '/empresa',
        '/sla',
        '/admin/upload-nf-retroativa',
    ];

    useEffect(() => {
        const pathname = location.pathname;
        const search = location.search;
        // fullPath preserva query string — essencial para páginas filtradas por evento
        const fullPath = pathname + search;

        if (ignorarRota(pathname)) return;

        const label = getLabel(pathname);
        if (!label) return; // rota desconhecida, não adiciona

        // Rota top-level (item direto do menu): reseta o trail para apenas este item
        if (TOP_LEVEL_ROUTES.includes(pathname)) {
            const novoTrail = [{ path: fullPath, label }];
            sessionStorage.setItem('bc_trail', JSON.stringify(novoTrail));
            setTrail(novoTrail);
            return;
        }

        setTrail(prev => {
            // Se é exatamente a mesma URL (pathname + search), não faz nada
            if (prev.length > 0 && prev[prev.length - 1].path === fullPath) return prev;

            // Deduplicação usa apenas pathname (sem search e sem ID),
            // para que /orcamento?evento=1 e /orcamento?evento=2 substituam o mesmo slot
            const basePath = pathname.replace(/\/[^/]+$/, '') || pathname;
            const idxExistente = prev.findIndex(item => {
                const itemPathname = item.path.split('?')[0]; // remove search do item salvo
                const itemBase = itemPathname.replace(/\/[^/]+$/, '') || itemPathname;
                return itemPathname === pathname || itemBase === basePath;
            });

            let novoTrail;
            if (idxExistente >= 0) {
                // Já existe no trail: atualiza com o fullPath atual e corta o que vem depois
                novoTrail = [
                    ...prev.slice(0, idxExistente),
                    { path: fullPath, label }
                ];
            } else {
                // Nova página: adiciona ao fim, mantém máximo 5
                novoTrail = [...prev, { path: fullPath, label }].slice(-5);
            }

            sessionStorage.setItem('bc_trail', JSON.stringify(novoTrail));
            return novoTrail;
        });
    }, [location.pathname, location.search]);

    // Permite que páginas individuais sobrescrevam o label do item atual
    const setCurrentLabel = useCallback((label) => {
        if (!label) return;
        setTrail(prev => {
            if (prev.length === 0) return prev;
            const last = prev[prev.length - 1];
            if (last.label === label) return prev; // sem mudança, evita loop
            const novoTrail = [...prev.slice(0, -1), { ...last, label }];
            sessionStorage.setItem('bc_trail', JSON.stringify(novoTrail));
            return novoTrail;
        });
    }, []);

    // Permite que páginas definam o trail completo (evita lixo histórico de outra seção)
    const setFullTrail = useCallback((novoTrail) => {
        if (!Array.isArray(novoTrail) || novoTrail.length === 0) return;
        setTrail(prev => {
            // Evita update desnecessário se trail já é idêntico
            if (JSON.stringify(prev) === JSON.stringify(novoTrail)) return prev;
            sessionStorage.setItem('bc_trail', JSON.stringify(novoTrail));
            return novoTrail;
        });
    }, []);

    return (
        <BreadcrumbContext.Provider value={{ trail, setCurrentLabel, setFullTrail }}>
            {children}
        </BreadcrumbContext.Provider>
    );
}

export function useBreadcrumb() {
    return useContext(BreadcrumbContext).trail;
}

// Hook para páginas sobrescreverem o label do item atual na trilha
export function useSetBreadcrumbLabel() {
    return useContext(BreadcrumbContext).setCurrentLabel;
}

// Hook para páginas definirem o trail completo de uma vez
export function useSetFullBreadcrumbTrail() {
    return useContext(BreadcrumbContext).setFullTrail;
}
